import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import DictionaryTable from '../components/DictionaryTable';
import { dictionaryAPI, type DictionaryEntry, type Group } from '../services/api';

export default function GroupView() {
  const { groupId } = useParams<{ groupId: string }>();
  const [group, setGroup] = useState<Group | null>(null);
  const [entries, setEntries] = useState<DictionaryEntry[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (groupId) {
      loadGroup();
    }
  }, [groupId]);

  const loadGroup = async () => {
    try {
      setLoading(true);
      const data = await dictionaryAPI.getGroup(parseInt(groupId!, 10));
      setGroup(data.group);
      setEntries(data.entries);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="text-center py-8">Loading...</div>;
  }

  if (error) {
    return (
      <div className="card">
        <div className="text-center py-8">
          <div className="text-red-600 font-semibold mb-2">Error: {error}</div>
          <p className="text-sm text-gray-600 mt-4">
            Make sure the backend server is running on port 8787.
          </p>
        </div>
      </div>
    );
  }

  if (!group) {
    return <div className="text-center py-8">Group not found</div>;
  }

  return (
    <div>
      <div className="mb-6">
        <Link to="/" className="text-primary-600 hover:text-primary-800 text-sm">
          ← Back to Dashboard
        </Link>
        <h1 className="text-3xl font-bold text-gray-900 mt-2">{group.group_name}</h1>
        <p className="text-gray-600 mt-1">Group ID: {group.group_id}</p>
        {group.description && (
          <p className="text-gray-600 mt-2">{group.description}</p>
        )}
      </div>

      <DictionaryTable data={entries} />
    </div>
  );
}

